









import Vue from "vue";
import axios from "axios";

async function testDelay(timeout: number) {
    const timerName = `delay_${timeout}`;

    console.time(timerName);
    console.log(`request DELAY ${timeout} start`);
    await axios
        .get(`api/v1/debug/delay/${timeout}`, { withCredentials: true })
        .then(function(response) {
            // console.log(`RESPONSE DATA: ${response.data}`);
            console.timeEnd(timerName);
        })
        .catch(function(error) {
            console.error("ERROR");
            console.log(error);
            console.timeEnd(timerName);
        });
}

export default Vue.extend({
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        async testNow() {
            this.isLoading = true;
            console.log("TEST NOW CALLED");
            const timerName = `total_timer`;
            console.time(timerName);
            await Promise.all([testDelay(1000), testDelay(2000), testDelay(4000)]);
            console.timeEnd(timerName);
            this.isLoading = false;
        },
    },
});
